import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from './CustomScalarAdapters.mjs';
import { ResponseParser_instance3eed22vymtbqx as ResponseParser_instance } from './internal/ResponseParser.mjs';
import {
  JsonDataException2rdtm884tky1l as JsonDataException,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
} from '../exception/Exceptions.mjs';
import { Token_END_DOCUMENT_getInstanceq7szdjm8kumg as Token_END_DOCUMENT_getInstance } from './json/JsonReader.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from './ApolloResponse.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toApolloResponse(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers) {
  requestUuid = requestUuid === VOID ? null : requestUuid;
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().v45_1 : customScalarAdapters;
  deferredFragmentIdentifiers = deferredFragmentIdentifiers === VOID ? null : deferredFragmentIdentifiers;
  // Inline function 'okio.use' call
  var thrown = null;
  var tmp;
  try {
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var this_0 = ResponseParser_instance.d47(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers);
      if (!_this__u8e3s4.d40().equals(Token_END_DOCUMENT_getInstance())) {
        throw JsonDataException().i47('Expected END_DOCUMENT but was ' + _this__u8e3s4.d40().toString());
      }
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var throwable = $p;
        var tmp1_requestUuid = requestUuid == null ? uuid4() : requestUuid;
        tmp_1 = Builder().b44(operation, tmp1_requestUuid).g44(wrapIfNeeded(throwable)).i44(true).n37();
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var t = $p;
      thrown = t;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp = tmp_2;
  }
  finally {
    try {
      if (_this__u8e3s4 == null)
        null;
      else {
        _this__u8e3s4.q6();
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t_0 = $p;
        if (thrown == null) {
          thrown = t_0;
        } else {
          addSuppressed(thrown, t_0);
        }
      } else {
        throw $p;
      }
    }
  }
  var result = tmp;
  if (!(thrown == null))
    throw thrown;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function parseResponse(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers) {
  requestUuid = requestUuid === VOID ? null : requestUuid;
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().v45_1 : customScalarAdapters;
  deferredFragmentIdentifiers = deferredFragmentIdentifiers === VOID ? null : deferredFragmentIdentifiers;
  var tmp;
  try {
    tmp = ResponseParser_instance.d47(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var throwable = $p;
      var tmp1_requestUuid = requestUuid == null ? uuid4() : requestUuid;
      tmp_0 = Builder().b44(operation, tmp1_requestUuid).g44(wrapIfNeeded(throwable)).i44(true).n37();
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function wrapIfNeeded(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ApolloException()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = ApolloNetworkException().o47('Error while reading JSON response', _this__u8e3s4);
  }
  return tmp;
}
//region block: exports
export {
  parseResponse as parseResponse2l74cu4whks78,
  toApolloResponse as toApolloResponse9u5mcqg84l2p,
};
//endregion

//# sourceMappingURL=Operations.mjs.map
